"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.AccordionMenu = void 0;
var _testidGenerator = _interopRequireDefault(require("@ori/testid-generator"));
var _AccordionMenuItem = require("./AccordionMenuItem");
var _jsxRuntime = require("react/jsx-runtime");
const AccordionMenu = ({
  menuItems,
  menuClickedItem,
  onMenuClick
}) => {
  const {
    getTestIdProps
  } = (0, _testidGenerator.default)();
  return /*#__PURE__*/(0, _jsxRuntime.jsx)("ul", {
    ...getTestIdProps('AccordionMenu'),
    children: menuItems.map(item => /*#__PURE__*/(0, _jsxRuntime.jsx)(_AccordionMenuItem.AccordionMenuItem, {
      menuItem: item,
      menuClickedItem: menuClickedItem,
      onMenuClick: onMenuClick
    }, `accordion-${item.itemPath}`))
  }, "AccordionMenu");
};
exports.AccordionMenu = AccordionMenu;
